import { render } from "./imageWithMark.vue?vue&type=template&id=aff5d8a4"
import script from "./imageWithMark.vue?vue&type=script&lang=js"
export * from "./imageWithMark.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__